import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-notification-layout',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification-layout.html',
  styleUrl: './notification-layout.scss',
})
export class NotificationLayout {
  public logoSrc = '/img/white-logo.svg';

  @Input() mobileImageSrc = '/public/hero-mobile.png';

  @Input() desktopImageSrc = '/public/hero-desktop.png';
  @Input() title = '';
  @Input() subtitle = '';
  @Input() showFooter = true;
  @Input() class = '';
}
